// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tQ0qzP0GIZcTFNJ6BVnG {
  max-width: 100px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/components/FlowSheetEditor/components/SetOperations/styles.module.less"],"names":[],"mappings":"AACA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAAF","sourcesContent":["\n.varName {\n  max-width: 100px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"varName": `tQ0qzP0GIZcTFNJ6BVnG`
};
export default ___CSS_LOADER_EXPORT___;
